import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { DialogService, SelectOption } from '@bcl/design-system';
import { ConsumablesDialogComponent } from './consumables-dialog.component';
import { environment } from 'src/environments';
import { Observable } from 'rxjs';
import { MonitorProduct } from 'src/app/pages/area/area.model';

export type AddProductDialogData = {
  warehouses: SelectOption[];
  products: SelectOption[];
  units: SelectOption[];
  product?: MonitorProduct;
  operationType: string;
  defaultCar?: number;
  sameMonitorsCount?: number;
  moduleId?: string;
  monitorId?: number;
  newMonitorId?: number;
  visitId?: number;
  modules?: SelectOption[];
};

export type AddProductResult = {
  productId: string;
  amount: number;
  unitId: string;
  initialDate: Date;
  warehouseId: string;
  supplierId: string;
  action: string;
  monitorProductId: number;
  executeAll: boolean;
  executeSelected: boolean;
  selectedMonitors: number[];
  allowToDisappear: boolean;
};

@Injectable({
  providedIn: 'root',
})
export class AddProductService {
  constructor(private dialog: DialogService, private http: HttpClient) {}

  public open(
    settings: MatDialogConfig<AddProductDialogData>
  ): MatDialogRef<ConsumablesDialogComponent, AddProductResult | undefined> {
    return this.dialog.open(ConsumablesDialogComponent, {
      minWidth: '90vw',
      ...settings,
    });
  }

  public getProductsForWarehouse(warehouseId: number, moduleId?: string): any {
    const url = environment.apiHost + '/stock/list';
    const params: any = {
      warehouseId: warehouseId.toString(),
      inStock: true,
      active: true,
      pageNumber: 1,
      pageSize: 100000,
    };

    if (moduleId) {
      params.moduleId = moduleId;
    }

    return this.http.get(url, { params });
  }

  public getSuppliersForProduct(productId: number): any {
    const url = environment.apiHost + '/stock/products/details/suppliers';
    return this.http.get(url, {
      params: {
        productId: productId.toString(),
        pageNumber: 1,
        pageSize: 10000,
      },
    });
  }

  public addMonitorProduct(details: any): any {
    const url = `${environment.apiHost}/locations/area/monitors/product`;
    const body = details;

    return this.http.post(url, body);
  }
  public editMonitorProduct(details: any): any {
    const url = `${environment.apiHost}/locations/area/monitors/product`;
    const body = details;

    return this.http.patch(url, body);
  }
  public deleteMonitorProduct(monitorProductId: number): any {
    const url = `${environment.apiHost}/locations/area/monitors/product/${monitorProductId}`;

    return this.http.delete(url);
  }
  public deleteMonitorProductAll(
    monitorProductId: number,
    visitId: number
  ): any {
    const url = `${environment.apiHost}/locations/area/monitors/product/forall/${monitorProductId}/${visitId}`;

    return this.http.delete(url);
  }

  public deleteMonitorProductSelected(
    monitorProductId: number,
    visitId: number,
    selectedMonitors: number[]
  ): any {
    const url = `${environment.apiHost}/locations/area/monitors/product/forselected/${monitorProductId}/${visitId}`;
    const body = { selectedMonitors };
    return this.http.patch(url, body);
  }

  public getMonitorsForSelection(
    monitorId: number,
    visitId: number
  ): Observable<any> {
    const url = `${environment.apiHost}/mobile/area/monitor/available-monitors`;
    return this.http.get(url, {
      params: {
        monitorId: monitorId.toString(),
        visitId: visitId.toString(),
      },
    });
  }
}
